// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"79":"d6cd9205","370":"4106624d","377":"dd1b1bba","825":"921361bb"}[chunkId] + ".chunk.js";
};